// create long title for event/moment
export default function getLongTitle(event) {
  if (event) {
    if (event.moment && event.moment.title) return event.moment.title;
    if (event.title) return event.title;
  }
  return "---";
}
